import { z } from 'zod';
import { CoreThumbnailStatusSchema } from '../inputTypeSchemas/CoreThumbnailStatusSchema'

/////////////////////////////////////////
// CORE THUMBNAIL SCHEMA
/////////////////////////////////////////

export const CoreThumbnailSchema = z.object({
  status: CoreThumbnailStatusSchema,
  id: z.number().int(),
  sourceFileId: z.string(),
  fileId: z.string().nullable(),
  heightPx: z.number().int(),
  widthPx: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CoreThumbnail = z.infer<typeof CoreThumbnailSchema>

export default CoreThumbnailSchema;
